import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../../style';

const cssPrefix = 'WelcomeChannel';

export namespace SettingsWelcomeChannelStyles {

  export const settingsDescription: React.CSSProperties = {
    margin: 0,
    marginBottom: '1em'
  };

  export const Editor = cssClass(cssPrefix, 'editor', {
    height: '100px',
    padding: '10px',
    outline: '1px solid '+applyColor(DesignTokens.color.elevation.border.inverse.clear, 'black'),
  });

  export const FooterPreviewContainerStyle: React.CSSProperties = {
    margin: '20px 0',
    marginBottom: '5px'
  };

  export const CharacterCounterStyle: React.CSSProperties = {
    fontSize: TabStyles.Typography.Sizing.Default,
    marginBottom: '18px'
  };

  export const WelcomeChannelPreviewContainer: React.CSSProperties = {
    opacity: 0.33
  };

  export const FooterContainer = cssClass(cssPrefix, 'footer_container', {
    position: 'relative'
  });
}
